<template>
  <div class="max-w-full max-h-150">
    <ResourceDetailsHeader />
  </div>
  <div class="max-w-full max-h-150 overflow-auto">
    <div v-if="isActiveSection(resourceSection)">
      <resource-info :resource="resource" />
    </div>
    <div v-else-if="isActiveSection(distributionSection)">
      <distributions :resource="resource" />
    </div>
  </div>
</template>

<script>
import ResourceDetailsHeader from '@/components/details-components/ResourceDetailsHeader'
import { computed, onBeforeMount, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import ResourceInfo from '@/components/details-components/ResourceInfo'
import DataFields from '@/components/details-components/DataFields'
import DataSample from '@/components/details-components/DataSample'
import PythonExample from '@/components/details-components/PythonExample'
import Distributions from '@/components/details-components/Distributions'
export default {
  name: 'ExternalResourceDetails',
  components: { Distributions, ResourceInfo, ResourceDetailsHeader },
  setup() {
    const store = useStore()
    function isActiveSection(section) {
      return activeSection.value === section.id
    }

    const resourceSection = { label: 'Resource Information', id: 'resourceInfo', icon: 'fas fa-circle-info' }
    const distributionSection = { label: 'Distributions', id: 'distributions', icon: 'fab fa-cloud-arrow-down' }

    const detailsSections = [resourceSection, distributionSection]

    const activeSection = computed(() => store.state.Details.activeSection.id)

    const resource = computed(() => {
      const r = store.state.Details.resource
      if (r === undefined) {
        return {
          title: '',
          publisher: {
            name: '',
          },
          identification: {
            dates: {
              creation: 'invalid',
              publication: 'invalid',
              revision: 'invalid',
            },
          },
        }
      }
      return r
    })

    onBeforeMount(() => {
      store.state.Details.availableSections = detailsSections
      store.state.Details.activeSection = resourceSection
    })

    return { activeSection, isActiveSection, detailsSections, resourceSection, distributionSection, resource }
  },
}
</script>

<style scoped>

</style>
